import { render, staticRenderFns } from "./SCardStemdoer.vue?vue&type=template&id=1a4db828&scoped=true"
import script from "./sCardStemdoer.ts?vue&type=script&lang=ts&external"
export * from "./sCardStemdoer.ts?vue&type=script&lang=ts&external"
import style0 from "./SCardStemdoer.vue?vue&type=style&index=0&id=1a4db828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4db828",
  null
  
)

export default component.exports